import { types } from "../Types/agent";
import { CreateAvatarPayload } from "../Sagas/agent/api";

// Agent
export const getAgent = () => ({ type: types.GET_AGENT });
export const updateAgent = (payload: any) => ({ type: types.UPDATE_AGENT, payload });
export const addAgentExample = (payload: { situation: string; preferredResponse: string }) => ({
  type: types.ADD_AGENT_EXAMPLE,
  payload,
});
// Saves the full remaining example list (PUT /ai/agent is a partial update).
export const removeAgentExample = (approvedExamples: any[]) => ({
  type: types.REMOVE_AGENT_EXAMPLE,
  payload: { approvedExamples },
});
export const testAgent = (payload: { subject: string; body: string }) => ({
  type: types.TEST_AGENT,
  payload,
});
export const clearAgentTest = () => ({ type: types.CLEAR_AGENT_TEST });

// Inbox + drafts
export const getInboxMessages = () => ({ type: types.GET_INBOX_MESSAGES });
export const getDraftStats = () => ({ type: types.GET_DRAFT_STATS });
export const generateDraft = (inboundMessageId: string, force?: boolean) => ({
  type: types.GENERATE_DRAFT,
  payload: { inboundMessageId, force },
});
// Background refresh of one draft (used for video polling).
export const fetchDraft = (id: string) => ({ type: types.FETCH_DRAFT, payload: { id } });
export const updateDraftBody = (id: string, body: string) => ({
  type: types.UPDATE_DRAFT_BODY,
  payload: { id, body },
});
export const decideDraft = (id: string, action: "approve" | "reject", body?: string) => ({
  type: types.DECIDE_DRAFT,
  payload: { id, action, body },
});
export const sendDraft = (id: string) => ({ type: types.SEND_DRAFT, payload: { id } });
export const createDraftVideo = (id: string, avatarId?: string) => ({
  type: types.CREATE_DRAFT_VIDEO,
  payload: { id, avatarId },
});

// Live mailbox sync
export const getWatch = () => ({ type: types.GET_WATCH });
export const startWatch = () => ({ type: types.START_WATCH });
export const stopWatch = () => ({ type: types.STOP_WATCH });

// Avatars
export const getAvatars = () => ({ type: types.GET_AVATARS });
export const getStockFaces = () => ({ type: types.GET_STOCK_FACES });
export const createAvatar = (payload: CreateAvatarPayload) => ({ type: types.CREATE_AVATAR, payload });
export const syncAvatar = (id: string) => ({ type: types.SYNC_AVATAR, payload: { id } });
export const setDefaultAvatar = (id: string) => ({ type: types.SET_DEFAULT_AVATAR, payload: { id } });
export const deleteAvatar = (id: string) => ({ type: types.DELETE_AVATAR, payload: { id } });
